<template>
    <team-list></team-list>
</template>

<script>
import TeamList from '../components/teamList/index'
export default {
    components:{TeamList},
    data() {
        return {
        }
    }
}
</script>